import * as Sentry from "@sentry/react";
import type { ReactElement, ReactNode } from "react";

import styles from "./ErrorBoundary.module.css";

import { ButtonV2 } from "@/components/atoms/Button";
import { ErrorScreen } from "@/components/organisms/ErrorScreen";
import { i18n } from "@/i18n";

interface Props {
  children: ReactNode;
  fallback?: ReactElement;
}

const handleReset = (): void => {
  window.location.reload();
};

const DefaultFallback = () => (
  <div className={styles.fallback}>
    <ErrorScreen
      title={i18n.t("common.errorBoundary.title")}
      description={i18n.t("common.errorBoundary.description")}
      action={
        <ButtonV2 onClick={handleReset}>
          {i18n.t("common.errorBoundary.tryAgain")}
        </ButtonV2>
      }
    />
  </div>
);

export const ErrorBoundary = ({ children, fallback }: Props) => (
  <Sentry.ErrorBoundary fallback={fallback ?? <DefaultFallback />}>
    {children}
  </Sentry.ErrorBoundary>
);
